import { motion } from "framer-motion";
import { CheckCircle2, Clock } from "lucide-react";

type PartnerStatus = "active" | "soon";

interface Partner {
  name: string;
  short: string;
  caption: string;
  status: PartnerStatus;
  accent: string; // tailwind text color class
}

const partners: Partner[] = [
  {
    name: "VK ORD",
    short: "VK",
    caption: "Прямая API-интеграция · доступно на бесплатном тарифе",
    status: "active",
    accent: "text-[hsl(210_85%_60%)]",
  },
  {
    name: "Ozon ORD",
    short: "Ozon",
    caption: "Через защищённый relay · тарифы Старт и выше",
    status: "active",
    accent: "text-[hsl(210_85%_60%)]",
  },
  {
    name: "ЕРИР (Роскомнадзор)",
    short: "ЕРИР",
    caption: "Автоматическая выгрузка отчётности по ФЗ-347",
    status: "active",
    accent: "text-[hsl(210_85%_60%)]",
  },
];

export function OrdPartnersStrip() {
  return (
    <section
      aria-labelledby="ord-partners-title"
      className="mt-20 w-full max-w-6xl px-2"
    >
      <div className="mb-8 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary/80">
          Аккредитованные операторы рекламных данных
        </p>
        <h2
          id="ord-partners-title"
          className="mt-3 text-2xl font-semibold text-foreground sm:text-3xl"
        >
          Прямые интеграции со всеми ОРД, аккредитованными Роскомнадзором
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-muted-foreground">
          ERIDON отправляет erid и отчёты в ЕРИР через сертифицированных
          операторов. Никаких ручных загрузок — соответствие ФЗ-347
          обеспечивается на уровне инфраструктуры.
        </p>
      </div>

      <ul className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        {partners.map((p, i) => (
          <motion.li
            key={p.name}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.05 }}
            className="group glass-card flex flex-col items-center justify-between gap-3 px-3 py-5 text-center transition-colors hover:border-primary/40"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-border/60 bg-secondary/30 font-bold tracking-tight">
              <span className={p.accent}>{p.short}</span>
            </div>
            <div className="space-y-1">
              <div className="text-sm font-semibold text-foreground">
                {p.name}
              </div>
              <p className="text-[11px] leading-snug text-muted-foreground">
                {p.caption}
              </p>
            </div>
            <div
              className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium ${
                p.status === "active"
                  ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-400"
                  : "border-amber-500/30 bg-amber-500/10 text-amber-400"
              }`}
            >
              {p.status === "active" ? (
                <>
                  <CheckCircle2 className="h-3 w-3" /> Активно
                </>
              ) : (
                <>
                  <Clock className="h-3 w-3" /> Скоро
                </>
              )}
            </div>
          </motion.li>
        ))}
      </ul>

      <p className="mx-auto mt-6 max-w-3xl text-center text-xs text-muted-foreground">
        Бесплатный тариф (5 erid через VK ORD) и платные тарифы Старт / Бизнес /
        Агентство используют одни и те же сертифицированные каналы передачи
        данных — VK ORD и Ozon ORD. Подробнее о лимитах — на странице{" "}
        <a href="/pricing" className="text-primary underline-offset-4 hover:underline">
          тарифов
        </a>
        .
      </p>
    </section>
  );
}
